<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "CustomerIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
